/* 孫吳傳・第 5 章：牛渚破營（興平二年，195）
 * 史實：《三國志·孫策傳》「策渡江轉鬬，所向皆破，莫敢當其鋒」；裴注引《江表傳》：攻破劉繇的牛渚營，「盡得邸閣糧穀、戰具」。
 * 流程：孫策帶江東兵搭船渡江（右鍵點江面划船）；靠近東岸時岸上弓手放箭（先預告），只有中段的淺灘能靠岸 →
 *       登岸，殺光邸閣附近的守兵，站在糧倉旁奪下邸閣 → 牛渚營的商舖開放 → 擋住劉繇的反撲，即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS, rout } from '../kit.ts';
import { BEACH, GRANARY } from '../maps/niuzhu.ts';

const LV = 6, LAUNCH = [2950, 2500], EAST = [7600, 2400];
const FOE = { spec: TROOPS.liuyao, name: '劉繇兵' };
const landOk = (x, y) => SG.gd(x, y, BEACH[0], BEACH[1]) < 520;

export default {
  id: 'sunwu-5', map: 'niuzhu', hero: 'sunce',
  title: '第 4 章　牛渚破營', year: '興平二年（195）',
  brief: {
    quote: [{ text: '策渡江轉鬬，所向皆破，莫敢當其鋒。', src: '《三國志·吳書·孫策傳》' }],
    text: '孫堅死後，孫策依附袁術，帶著父親的舊部借兵渡江。對岸是揚州刺史劉繇的牛渚營，營中的邸閣存著大批糧穀與戰具。',
    goals: ['搭船渡江，從淺灘登岸', '奪下牛渚營的邸閣', '擋住劉繇的反撲'],
  },
  words: { ally: '江東兵', foe: '劉繇兵' },
  stars: [
    { text: '渡江時沒有折損一艘船上的人', ok: (m) => !m.vars.boatLoss },
    { text: '登岸後 90 秒內奪下邸閣', ok: (m) => m.vars.takeT != null && m.vars.takeT - m.vars.landT <= 90 },
    { text: '江東兵折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
  ],
  steps: [
    { // 1. 渡江
      enter(m, w) {
        const me = w.player;
        setLevel(w, me, LV);
        me.x = LAUNCH[0]; me.y = LAUNCH[1];
        // 三艘船：孫策的旗艦（玩家划），兩艘跟著
        const crew = (n, x, y) => Array.from({ length: n }, () => m.recruit(x, y, '江東兵'));
        const mine = crew(5, LAUNCH[0], LAUNCH[1]);
        m.vars.b0 = m.boat(me, { sp: 170, crew: mine, land: true, landOk, flag: '#c0302a', onLand: (b) => onLand(m, w, b) });
        m.vars.boats = [[2950, 2150], [2950, 2850]].map(([x, y]) => {
          const lead = m.recruit(x, y, '江東兵'), c = crew(4, x, y);
          const b = m.boat(lead, { x, y, crew: c, land: true, landOk, flag: '#c0302a', sp: 160, onLand: (bb) => onLand(m, w, bb) });
          b.goal = [BEACH[0] + 100, BEACH[1] + (y < 2500 ? -160 : 160)];
          return b;
        });
        m.vars.all = mine.concat(...m.vars.boats.map((b) => [b.u, ...b.crew]));
        m.vars.n0 = m.vars.all.length;
        m.mark('beach', BEACH[0], BEACH[1], '淺灘');
        m.obj('cross', '渡江，從淺灘登岸');
        m.line('孫策', '渡江！奪下劉繇的牛渚營！');
        m.after(3, () => m.line('提示', '你在船上：右鍵點江面就往那裡划。東岸只有中段的淺灘能靠岸，岸上有弓手。'));
        m.vars.shore = Array.from({ length: 8 }, (_, i) => m.foe('huangjin', 4800 + (i % 2) * 120, 1900 + i * 160, FOE));
      },
      tick(m, w, dt) {
        const V = m.vars, me = w.player;
        // 岸上的弓手：船靠近東岸 900 以內，就往船前方射一陣
        V.arrowT = (V.arrowT || 1) - dt;
        if (V.arrowT <= 0) {
          V.arrowT = 1.8;
          for (const b of m.boats) {
            if (b.x < 3700 || SG.rand() < 0.4) continue;
            const g = b.goal || [b.x, b.y], d = Math.hypot(g[0] - b.x, g[1] - b.y) || 1, lead = Math.min(1, d / b.sp) * b.sp * 1.2;
            m.strike(b.x + ((g[0] - b.x) / d) * lead * (b.u === me ? 1 : 0.6), b.y + ((g[1] - b.y) / d) * lead * 0.7, 130, 1.2, 50, 0, { col: '#ff5040' });
          }
        }
        if (!V.boatLoss && V.all.some((u) => !u.alive)) V.boatLoss = true;
        return !me.boat;
      },
    },
    { // 2. 奪邸閣
      enter(m, w) {
        const V = m.vars;
        V.landT = w.t;
        m.done('cross'); m.unmark('beach');
        m.big('登岸！');
        V.guard = m.camp(GRANARY[0], GRANARY[1], [['huangjin', 9], ['bandit', 2]], 320).map((u) => Object.assign(u, { spec: TROOPS.liuyao, name: u.kind === 'creep' && u.maxHp > 900 ? '劉繇部將' : '劉繇兵' }));
        V.cp = ally(w, 'chengpu', w.player.x - 120, w.player.y + 80, LV);
        m.after(1.5, () => m.line('程普', '伯符，邸閣就在營中！先殺散守兵！'));
        m.mark('granary', GRANARY[0], GRANARY[1], '邸閣');
        m.obj('take', '殺散邸閣的守兵，站在糧倉旁奪下邸閣');
        m.folk(GRANARY[0] + 60, GRANARY[1] - 40, { name: '邸閣', still: true, near: 1, draw: SG.campaignDraw.granary });
      },
      tick(m, w) {
        const V = m.vars, me = w.player;
        const left = V.guard.filter((u) => u.alive && SG.gd(u.x, u.y, GRANARY[0], GRANARY[1]) < 700).length;
        m.get('take').text = left ? `殺散邸閣的守兵（還有 ${left} 人）` : '站在糧倉旁奪下邸閣';
        if (!left) m.chanAt(me, 'take', GRANARY[0], GRANARY[1], 200, 2.5, '奪邸閣', () => { V.taken = true; });
        return !!V.taken;
      },
    },
    { // 3. 盡得邸閣糧穀、戰具；擋住反撲
      enter(m, w) {
        const V = m.vars;
        V.takeT = w.t;
        m.done('take'); m.unmark('granary');
        m.card('策渡江攻繇牛渚營，盡得邸閣糧穀、戰具。', '《江表傳》（〈孫策傳〉裴注）');
        SG.MAP.shops.push([GRANARY[0], GRANARY[1] + 120, 'village']);
        w.player.gold += 400;
        m.after(2, () => m.line('提示', '邸閣奪下了：繳獲 400 金，糧倉旁可以買裝備。劉繇的援軍就快到了。'));
        m.obj('hold', '擋住劉繇的反撲');
        V.counter = [];
        [6, 26].forEach((t, k) => m.after(t, () => {
          const list = Array.from({ length: 9 + k * 3 }, (_, i) => m.foe(i < 1 + k ? 'bandit' : 'huangjin', EAST[0] - (i % 3) * 80, EAST[1] - 200 + Math.floor(i / 3) * 110, Object.assign({}, FOE, i < 1 + k ? { name: '劉繇部將' } : {})));
          for (const u of list) u.home = [GRANARY[0] + 150, GRANARY[1] + (SG.rand() - 0.5) * 300];
          V.counter.push(...list);
          m.big(`劉繇的援軍（第 ${k + 1} 波）`);
        }));
      },
      tick(m, w) {
        const V = m.vars;
        if (m.t < 30 || m.alive(V.counter).length) return false;
        m.done('hold');
        m.line('孫策', '劉繇的兵不過如此！下一步，進逼曲阿！');
        m.after(2.5, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('孫策陣亡'); return; }
    if (m.vars.cp) allyTick(w, m.vars.cp, w.player);
  },
};

// 靠岸：船上的人下船，跟著孫策
function onLand(m, w, b) {
  for (const u of [b.u, ...b.crew]) if (u.alive && u !== w.player) { u.boat = null; m.join(u, w.player); }
}
